import type { z } from "zod";

import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  AccommodationsBadgeTypesDtoSchema,
  AccommodationsPageDtoSchema,
  AccommodationsPointDtoSchema,
  type AccommodationsPointSchema,
  AccommodationsTypesDtoSchema,
} from "./schemas";
import type {
  AccommodationsBadgeType,
  AccommodationsPageType,
  AccommodationsPoints,
  AccommodationsType,
} from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToAccommodationsPage = (
  dto: unknown,
): AccommodationsPageType => {
  const parsed = safeParseWithFallback(
    AccommodationsPageDtoSchema,
    dto,
    "mapDtoToAccommodationsPage",
  );

  return extractData(parsed, dto, dto as AccommodationsPageType);
};

export const mapDtoToAccommodationsPoints = (
  dto: unknown,
): AccommodationsPoints => {
  const parsed = safeParseWithFallback(
    AccommodationsPointDtoSchema,
    dto,
    "mapDtoToAccommodationsPoints",
  );

  const rawData = extractDataWithMeta<
    z.infer<typeof AccommodationsPointSchema>[],
    AccommodationsPoints["meta"]
  >(parsed, dto, defaultMeta as AccommodationsPoints["meta"]);

  return {
    data: rawData.data,
    meta: rawData.meta,
  };
};

export const mapDtoToAccommodationsTypes = (
  dto: unknown,
): AccommodationsType[] => {
  const parsed = safeParseWithFallback(
    AccommodationsTypesDtoSchema,
    dto,
    "mapDtoToAccommodationsTypes",
  );

  return extractData(parsed, dto, []);
};

export const mapDtoToAccommodationsBadgeTypes = (
  dto: unknown,
): AccommodationsBadgeType[] => {
  const parsed = safeParseWithFallback(
    AccommodationsBadgeTypesDtoSchema,
    dto,
    "mapDtoToAccommodationsBadgeTypes",
  );

  return extractData(parsed, dto, []);
};
